import { Component } from 'react';
import { Link } from 'react-scroll';
import {linkWithUtm} from "../../helpers/linkWithUtm";

const MAX_MOBILE_WIDTH = 550;

export default class ListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: false,
      mainPage: false // param for main page
    };
  }

  componentDidMount() {
    if (window.location.pathname === '/') {
      this.setState({
        mainPage: true
      });
    }
  }

  toggleHandler() {
    if (window.innerWidth > MAX_MOBILE_WIDTH) {
      return false;
    }

    this.setState({
      status: !this.state.status
    });
  }

  render() {
    const { submenu, mobileStatus } = this.props;

    return (
      <div
        className={`footer__up__item ${mobileStatus && '_mobile'} ${
          this.state.status && '_open'
        }`}
      >
        <div className={`footer__up__item__title`}>
          <button onClick={this.toggleHandler.bind(this)}>
            {
              submenu.link
              ? <a href={linkWithUtm(submenu.link)}>{submenu.title}</a>
              : <span>{submenu.title}</span>
            }
            <img
              src={require('../../static/images/icons/arrow-down.svg')}
              alt=""
            />
          </button>
        </div>
        <div className={`footer__up__item__content`}>
          <ul>
            {submenu.list.map((item) => {
              if (item.new_window) {
                return (
                  <li key={item.id}>
                    <a href={`${linkWithUtm(item.link)}`} rel="nofollow noopener" target="_blank">
                      {item.title}
                    </a>
                  </li>
                );
              } else {
                return (
                  <li key={item.id}>
                    <a href={`${linkWithUtm(item.link)}`}>{item.title}</a>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      </div>
    );
  }
}
